import { licenseCheckLatestStatusEntityName } from '../entities/types';
export function getLicenseCheckLatestStatusStorage(context) {
    return context.storage(licenseCheckLatestStatusEntityName);
}
